import type {
  ChatRenderItem,
  ConsolidationSurface,
  RenderablePart,
} from '../components/chat-message-list-grouping';

export function getConsolidatedGroupExpansionKey({
  items,
  surface,
}: {
  items: RenderablePart[];
  surface: ConsolidationSurface;
}): string | undefined {
  const firstItem = items[0];

  if (!firstItem) {
    return undefined;
  }

  return `consolidated-${surface}-${firstItem.processedPart.key}`;
}

export function getStableKeyForRenderItem(item: ChatRenderItem): string {
  switch (item.kind) {
    case 'user-message': {
      const { message, index } = item.processedMessage;

      return `user-${message.id ?? index}`;
    }

    case 'part':
      return `part-${item.item.processedPart.key}`;
    case 'sub-agent-group':
      return `group-${item.group.parent.processedPart.key}`;
    case 'feedback': {
      const { message, index } = item.processedMessage;

      return `feedback-${message.id ?? index}`;
    }

    case 'background-update-separator':
      return item.separatorKey;
    case 'pinned-plan-header':
      return item.key;
    case 'consolidated-group':
      return item.key;
  }
}
